import { useEffect } from 'react';
import { messaging, getToken, onMessage } from '../helpers/firebase';

import appAjax from '../helpers/ajax';
import appUi from '../helpers/ui';

import $ from 'jquery';

export const useNotifications = () => {
  var notificationRequested = false;

  useEffect(() => {
    if (notificationRequested) return;
    notificationRequested = true;

    // Handle foreground messages
    onMessage(messaging, (payload) => {
      // console.log('Foreground notification received:', payload);
      
      // Display notification using your preferred method (sweetalert2, etc.)
      // Example with native notification
      // new Notification(payload.notification.title, {
      //   body: payload.notification.body,
      //   icon: payload.notification.icon,
      // });

      appUi.uiToast(payload.notification.title, 'info');

      var elTitle = $('<b>').text(payload.notification.title);
      var elBody = $('<span>').text(payload.notification.body);
      var elContent = $('<div style="font-size: 14px;">').append(elTitle).append('<br />').append(elBody);

      appAjax.addBubble({
        dom: elContent,
      }, 'notification');
    });
  }, []);
};
